import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Footer from "@/components/Footer";
import Navigation from "@/components/Navigation";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { CookieConsent } from "@/components/CookieConsent";
import Datenschutz from "@/pages/Datenschutz";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";

const App: React.FC = () => {
	return (
		<Router>
			<ScrollToTop />
			<div className="min-h-screen bg-black">
				<Navigation />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/impressum" element={<Impressum />} />
					<Route path="/datenschutz" element={<Datenschutz />} />
				</Routes>
				<Footer />
				<WhatsAppFloat />
				<CookieConsent />
			</div>
		</Router>
	);
};

export default App;
